import URLS from "./UrlConfig";
import futch from "./Api";

export async function getTokenApi(data) {
  var urlApi = URLS.baseURL[0] + URLS.login;
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  let raw = JSON.stringify(data);
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const Response = await futch(urlApi, requestOptions);
  return Response;
}

export async function checkToken(token) {
  var urlApi = URLS.baseURL[0] + URLS.checkToken;
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + token);
  let raw = JSON.stringify({});
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const Response = await futch(urlApi, requestOptions);
  return Response;
}

export async function logout(token) {
  var urlApi = URLS.baseURL[0] + URLS.logout;
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + token);
  let raw = JSON.stringify({});
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const Response = await futch(urlApi, requestOptions);
  return Response;
}
export async function ChangePasswordApi(token, values) {
  var urlApi = URLS.baseURL[0] + URLS.changepassword;
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + token);
  let raw = JSON.stringify(values);
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const Response = await futch(urlApi, requestOptions);
  return Response;
}
const exportDefault = {
  getTokenApi,
  checkToken,
  logout,
  ChangePasswordApi,
};

export default exportDefault;
